var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useState, useEffect, useCallback } from 'react';
import { getReportStatus } from '../services/sleepStudyReportStatusService';
/**
 * Custom hook to manage sleep study report status.
 * Checks if a new report is available.
 */
export const useReportStatus = ({ patientId, providerId = 'virtuox', enabled = true }) => {
    const [hasNewReport, setHasNewReport] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const fetchStatus = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (!patientId || !enabled) {
            setHasNewReport(false);
            setError(null);
            setLoading(false);
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const status = yield getReportStatus(providerId, patientId);
            setHasNewReport(status.hasNewReport);
        }
        catch (err) {
            // 404 means no order exists for this patient — not an error
            if (err === null || err === void 0 ? void 0 : err.isNotFound) {
                setHasNewReport(false);
            }
            else {
                const errorMessage = err instanceof Error ? err.message : 'Failed to fetch report status';
                setError(errorMessage);
            }
        }
        finally {
            setLoading(false);
        }
    }), [patientId, providerId, enabled]);
    useEffect(() => {
        fetchStatus();
    }, [fetchStatus]);
    return {
        hasNewReport,
        loading,
        error,
        refetch: fetchStatus
    };
};
